// extracted by mini-css-extract-plugin
export default {"donutChart":"DonutChart_donutChart__OYjJI","chartImage":"DonutChart_chartImage__qbqtZ","legend":"DonutChart_legend__hFzKt"};